import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { copilotMessagePublisherEnvironment } from '../copilot-message-publisher-environment';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Sends a CoPilot Request Action
 * @param accountId Account ID
 * @param userId Device ID
 * @param messageType Type of request to send
 * @param keytest1 Details on request sent
 * @param minutesToStoreMessage Duration of time to store message
 * @returns An object indicating success
 */
export function postPublish(
  this: unknown,
  accountId: number,
  userId: string,
  messageType: string,
  keytest1: string,
  minutesToStoreMessage: number
) {
  return fromFetch(
    new Request(copilotMessagePublisherEnvironment.resolve(this).publishUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        accountId,
        userId,
        messageType,
        message: {
          keytest1,
        },
        minutesToStoreMessage,
        publisherApplication: 'copilot',
        subscriberApplications: ['copilot'],
        retainNotifications: false,
      }),
    })
  ).pipe(
    selectData(
      z.object({
        success: z.literal(true),
      })
    )
  );
}
